import React from 'react'
import { func, string } from 'prop-types'
import FaExclamationCircle from 'react-icons/lib/fa/exclamation-circle'

import styles from './InfoWarning.styl'

export default class InfoWarning extends React.Component {
	static propTypes = {
		info: string,
		close: func
	}
	componentDidMount() {
		document.body.style.overflow = 'hidden'
	}
	componentWillUnmount() {
		document.body.style.overflow = 'inherit'
	}
	closeTimeout(close) {
		setTimeout(() => {
			close()
		}, 1000)
	}
	render() {
		const { info, close } = this.props
		this.closeTimeout(close)
		return (
			<section className={ styles.message_popup_form }>
				<div className={ styles.message_success }>
					<div className={ styles.message_container }>
						<i><FaExclamationCircle color="#d2d2d2" /></i>
						<p>{ info }</p>
					</div>
				</div>
			</section>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/Messages/InfoWarning/InfoWarning.js